(function () {
  function handleize(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/['’]/g, "")
      .replace(/[^\w]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function skipValue(value) {
    var handle = handleize(value);
    return !value || handle === "none" || handle === "no-belt";
  }

  function expandValues(values) {
    var tokens = [];
    values.forEach(function (value) {
      if (skipValue(value)) return;
      tokens.push(String(value));
      tokens.push(handleize(value));
      String(value)
        .split(" / ")
        .forEach(function (part) {
          part = part.trim();
          if (!part) return;
          tokens.push(part);
          tokens.push(handleize(part));
        });
    });
    return tokens;
  }

  function tokenMatch(tokens, value) {
    if (!value) return false;
    return tokens.indexOf(String(value)) !== -1 || tokens.indexOf(handleize(value)) !== -1;
  }

  function variantWeight(variant) {
    var parsed = parseFloat(variant.display_weight || variant.weight);
    return isNaN(parsed) ? 0 : parsed;
  }

  function scoreVariant(variant, tokens) {
    if (variant.title === "Default Title") return 1;
    var score = 0;
    [variant.option1, variant.option2, variant.option3, variant.title].forEach(function (value) {
      if (!value) return;
      if (tokenMatch(tokens, value)) score += 2;
      var parts = String(value).split(" / ");
      if (parts.length > 1) {
        parts.forEach(function (part) {
          if (tokenMatch(tokens, part.trim())) score += 1;
        });
      }
    });
    return score;
  }

  function componentWeight(component, parentValues) {
    var variants = component.variants || [];
    if (!variants.length) return 0;
    var tokens = expandValues(parentValues);
    var best = variants[0];
    var bestScore = 0;
    variants.forEach(function (variant) {
      var score = scoreVariant(variant, tokens);
      if (score > bestScore) {
        bestScore = score;
        best = variant;
      }
    });
    return variantWeight(best);
  }

  function formatWeight(grams) {
    var ounces = grams * 0.03527396195;
    ounces = ounces < 1 ? Math.round(ounces * 100) / 100 : Math.round(ounces * 10) / 10;
    if (String(ounces).split(".")[1] === "0") ounces = parseInt(ounces, 10);
    if (String(grams).split(".")[1] === "0") grams = parseInt(grams, 10);
    return ounces + " oz / " + grams + " g";
  }

  function mapProduct(product) {
    return {
      id: product.id,
      handle: product.handle,
      title: product.title,
      variants: (product.variants || []).map(function (variant) {
        return {
          title: variant.title,
          option1: variant.option1,
          option2: variant.option2,
          option3: variant.option3,
          weight: variant.weight
        };
      })
    };
  }

  function parseGrams(text) {
    var match = String(text || "").match(/([\d.]+)\s*g/i);
    return match ? parseFloat(match[1]) : 0;
  }

  function updateWeights(components) {
    var select = document.querySelector(".product-single select[name='id'], .product-single .select-variants");
    if (!select) return;

    Array.prototype.forEach.call(select.options, function (option) {
      var parentValues = [
        option.getAttribute("data-option1"),
        option.getAttribute("data-option2"),
        option.getAttribute("data-option3")
      ];
      var total = 0;
      components.forEach(function (component) {
        total += componentWeight(component, parentValues);
      });
      if (!total) return;
      var existing = parseGrams(option.getAttribute("data-weight"));
      if (existing && total + 1 < existing) return;
      option.setAttribute("data-weight", formatWeight(total));
      option.textContent = option.textContent.replace(/\s-\s[\d.]+\s*$/, "") + " - " + total;
    });

    var selected = select.options[select.selectedIndex];
    var selectedWeight = selected && selected.getAttribute("data-weight");
    var weightEl = document.querySelector(".product-single .product__meta .product__info > span");
    if (selectedWeight && weightEl) {
      var existing = parseGrams(weightEl.textContent);
      var next = parseGrams(selectedWeight);
      if (!existing || next + 1 >= existing) weightEl.innerHTML = selectedWeight;
    }
  }

  function initBundleWeight() {
    var node = document.getElementById("BundleWeightConfig");
    if (!node) return;

    var config;
    try {
      config = JSON.parse(node.textContent);
    } catch (error) {
      return;
    }

    var byHandle = {};
    (config.components || []).forEach(function (component) {
      if (component && component.handle && component.handle !== config.productHandle) {
        byHandle[component.handle] = component;
      }
    });

    var handles = {};
    Object.keys(byHandle).forEach(function (handle) {
      handles[handle] = true;
    });
    (config.handles || []).forEach(function (handle) {
      if (handle) handles[handle] = true;
    });

    var fetches = Object.keys(handles).map(function (handle) {
      return fetch("/products/" + handle + ".js")
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (product) {
          if (product) byHandle[product.handle] = mapProduct(product);
        })
        .catch(function () {});
    });

    Promise.all(fetches).then(function () {
      var components = Object.keys(byHandle).map(function (handle) {
        return byHandle[handle];
      }).filter(function (component) {
        return component && component.variants && component.variants.length;
      });
      if (!components.length) return;
      updateWeights(components);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBundleWeight);
  } else {
    initBundleWeight();
  }
})();
